import React from 'react';

const ErrorStatus = ({ width = 20, height = 20, className, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      version="1.0"
      role="presentation"
      aria-hidden="true"
      {...rest}
    >
      <g id="Group 1000002173">
        <circle id="Ellipse 2332" cx="9" cy="9" r="9" fill="#CF222E" />
        <path
          id="Icon"
          d="M8.16699 12.1668C8.16699 11.8906 8.39085 11.6668 8.66699 11.6668H9.33366C9.6098 11.6668 9.83366 11.8906 9.83366 12.1668V12.9446C9.83366 13.2207 9.6098 13.4446 9.33366 13.4446H8.66699C8.39085 13.4446 8.16699 13.2207 8.16699 12.9446V12.1668ZM8.16699 5.05566C8.16699 4.77952 8.39085 4.55566 8.66699 4.55566H9.33366C9.6098 4.55566 9.83366 4.77952 9.83366 5.05566V9.389C9.83366 9.66514 9.6098 9.889 9.33366 9.889H8.66699C8.39085 9.889 8.16699 9.66514 8.16699 9.389V5.05566Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default ErrorStatus;
